import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const CookieInfoLayer = (props) => {
  return (
    <div
      style={{
        padding: '2rem 8%',
        textAlign: 'left',
        minHeight: 'calc(100vh - 200px)',
        // color: "#FFFFFF",
      }}
    >
      <Typography variant={'h1'}>COOKIE INFORMATION LAYER</Typography>
      <Typography variant={'body1'}>
        Mercedes-Benz Group AG uses cookies.
        <br />
        <br />
        On this website, only cookies that are technically necessary for its
        operation are used. <br /> <br />
        For more information, please refer to our{' '}
        <Link
          to='/cookiesuse'
          style={{ color: 'inherit', textDecoration: 'underline' }}
        >
          Cookie Statement
        </Link>
        .
        <br />
        <br />
        E-Mail:{' '}
        <a
          href='mailto:obl-management@mercedes-benz.com'
          style={{ color: 'inherit', textDecoration: 'underline' }}
        >
          obl-management@mercedes-benz.com
        </a>
      </Typography>
    </div>
  );
};

export { CookieInfoLayer };
